import { memo } from 'react';
import PropTypes from 'prop-types';
import MarkdownToHtml from '../../../../MarkdownToHtml';

const OverviewDetails = ({ content }) => <MarkdownToHtml content={content || ''} />;
OverviewDetails.propTypes = {
  content: PropTypes.string.isRequired,
};

export default memo(OverviewDetails);
